<template>

    <v-container fluid class="ma-0 pa-0">

        <!-- Startup Registered (expande/collapse) -->
        <v-layout row wrap pa-2>
            <v-flex xs12 pa-3>
                <v-card>
                    <v-card-title class="primary white--text title">
                        {{challenge.Title}}
                    </v-card-title>
                    <v-card-text>
                        <v-layout
                                justify-space-between
                                pa-3
                                row
                                wrap
                        >
                            <v-flex xs12 sm4 md4>
                                <v-treeview
                                        :items="items"
                                        :active.sync="active"
                                        item-text="Name"
                                        item-key="_id"
                                        activatable
                                        active-class="primary--text"
                                        open-on-click
                                        class="grey lighten-5"
                                        transition
                                        loading-icon="mdi-sync"
                                >
                                    <template v-slot:prepend="{ item, active }">
                                        <v-icon
                                                v-if="!item.children"
                                                :color="active ? 'primary' : ''"
                                        >
                                            mdi-account
                                        </v-icon>
                                    </template>
                                </v-treeview>
                            </v-flex>
                            <v-flex xs12 sm7 md7>
                                <v-layout d-flex fill-height align-center justify-center class="text-xs-center">
                                    <v-scroll-y-transition mode="out-in">
                                        <v-flex pa-2>
                                            <div
                                                    v-if="!selected"
                                                    class="title grey--text text--lighten-1 font-weight-light"
                                                    style="align-self: center;"
                                            >
                                                <span v-if="startupsBoolean">Select a Startup</span>
                                                <span v-else>No Startups Selected to this Challenge</span>
                                            </div>
                                            <v-card
                                                    v-else
                                                    :key="selected['_id']"
                                                    class="pt-1 mx-auto full-height"
                                                    flat
                                                    pa-2
                                            >
                                                <v-card-text class="pa-2">
                                                    <h3 class="headline mb-2">
                                                        {{ selected["Name"] }}
                                                    </h3>
                                                    <v-divider></v-divider>
                                                    <v-layout
                                                            row
                                                            wrap
                                                    >

                                                        <!--<v-flex xs12 v-for="value,key in selected" v-if="key !== 'token' && key !== '_id' && key !== 'Link to folder in Peers' && key !== 'approved'">
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>{{key}}: </strong>
                                                                    <a v-if="(key === 'Website' || key === 'Contact links' || key === 'Logo' || key === 'Crunchbase link') && value !== 'None' && value !== '-'" :href="value" target="_blank">link</a>
                                                                    <span v-else>{{value}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>-->
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Name: </strong>
                                                                    <span>{{selected['Name']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Area: </strong>
                                                                    <span>{{selected['Area']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Country: </strong>
                                                                    <span>{{selected['Country']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Region/city: </strong>
                                                                    <span>{{selected['Region / city']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Idea description: </strong>
                                                                    <span>{{selected['Idea description-EN']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Addressed market: </strong>
                                                                    <span>{{selected['Addressed MU']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Technology area: </strong>
                                                                    <span>{{selected['Technology area']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Vertical solution: </strong>
                                                                    <span>{{selected['Vertical solution (if any)']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Idea state: </strong>
                                                                    <span>{{selected['Idea state']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Patent: </strong>
                                                                    <span>{{selected['Patent']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Website: </strong>
                                                                    <a v-if="selected['Website'] !== 'None' && selected['Website'] !== '-'" :href="selected['Website']" target="_blank">link</a>
                                                                    <span v-else>{{selected['Website']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Foundation: </strong>
                                                                    <span>{{selected['Foundation']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1>
                                                                    <strong>Number Employees: </strong>
                                                                    <span>{{selected['NumberEmployees']}}</span>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <!--<v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1 pt-3 class="headline">
                                                                    Click the pdf icon to see their proposal for this challenge
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex mt-3>
                                                                    <v-avatar class="mb-2 clickable-cursor" size="50" tile @click="downloadFile">
                                                                        <v-img :src="require('@/assets/img/files/png/pdf.png')">
                                                                        </v-img>
                                                                    </v-avatar>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>-->
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex ma-1 pt-3 class="headline">
                                                                    Click the pdf icon to see their presentation
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12>
                                                            <v-layout column wrap align-center>
                                                                <v-flex mt-3>
                                                                    <a target="_blank" :href="'docs/oic11/'+selected['Name']+'.pdf'"><v-avatar class="mb-2 clickable-cursor" size="50" tile @click="downloadSlide">
                                                                        <v-img :src="require('@/assets/img/files/png/pdf.png')">
                                                                        </v-img>
                                                                    </v-avatar>
                                                                    </a>

                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-scroll-y-transition>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                </v-card>
            </v-flex>
        </v-layout>

    </v-container>


</template>

<script>
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";

    export default {
        name: "StartupGhostTreeView",
        props: {
            challenge: Object
        },
        data() {
            return {
                active: [],
                startups: [],
                startupsBoolean: false,
            }
        },
        created() {
        },
        computed: {
            items () {
                return this.startups
            },
            selected () {
                if (!this.active.length) return undefined
                const id = this.active[0]
                return this.startups.find(startup => startup['_id'] === id)
            },
        },
        watch:{
            challenge(c){
                this.startups = []
                this.active = []
                if(c._id !== undefined) this.getStartups(c)
            }
        },
        methods: {
            downloadSlide(){

            },
            getStartups(c){
                let requestUrl = {
                    url: UrlsService.challengesGhost,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "STARTUPS",
                        challengeRequest: {
                            challenge: {
                                _id: c._id,
                            }
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Startups",
                    loading: "Waiting for list of startups...",
                    error: "Cannot get startups...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                return APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.startups = [];
                        let responseStartups = responseSuccess.response.startups;
                        this.startups = responseStartups;
                        /*for (let i = 0; i < responseStartups.length; i++) {
                            this.startups.push({
                                id: responseStartups[i]["_id"],
                                name: responseStartups[i]["Name"],
                                country: responseStartups[i]["Country"],
                                contactName: responseStartups[i]["Contact name"],
                                contactDetails: responseStartups[i]["Contact details"],
                                market: responseStartups[i]["Addressed MU"],
                                website: responseStartups[i]["Website"],

                            });
                        }*/

                        if(responseStartups.length > 0) this.startupsBoolean = true;
                        else this.startupsBoolean = false;
                    });
            },
            downloadFile() {
                let requestUrl = {
                    url: UrlsService.getFileStartupRegisteredToChallenge,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        challengeRequest: {
                            challenge: {
                                _id: this.challenge._id,
                            }

                        },
                        startupRequest: {
                            startup:{
                                _id: this.selected["_id"],
                            },
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Download Attachment",
                    loading: "Waiting for attachment downloading...",
                    error: "Cannot download attachment...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let responseStartups = responseSuccess.response.file;

                        const base64Sourvce = responseStartups;
                        const downloadLink = document.createElement("a");
                        const fileName = this.selected["Name"] + "_attachment.pdf";

                        downloadLink.href = base64Sourvce;
                        downloadLink.download = fileName;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                    });
            },
        }

    }
</script>

<style scoped>
    .clickable-cursor{
        cursor: pointer;
    }

</style>